namespace GeniuzPOS.InventoryReport {
    export class IcReport06Columns {
        static columnsKey = 'InventoryReport.IcReport06';
    }
}
